import $ from 'jquery';
import {FeeSchedule} from './FeeSchedule';
import RangeTable from './RangeTable';
import FeeTable from './FeeTable';

class FeeScheduleForm {

  constructor() {
  }

  isFeeScheduleForm() {
    return this.$form.length > 0;
  }

  init() {
    this.$form = $('#fee_schedule_form');

    if (this.isFeeScheduleForm()) {
      this.initData();
      this.initForm();
    }
  }

  initData() {
    let data = $('#fee_schedule_data').data('json') || {};
    if (data.ranges === undefined) data.ranges = [];
    if (data.fees === undefined) data.fees = [];
    this.feeSchedule = new FeeSchedule(data);
  }

  initForm() {
    this.rangeTable = new RangeTable(this); 
    this.rangeTable.init();
    this.feeTable = new FeeTable(this); 
    this.feeTable.init();
  }

  load() {
    this.init();
  }
}

export default new FeeScheduleForm();
